var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonic2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.8 107.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3",
    "data-name": "Component 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3-2",
    "data-name": "Component 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    className: "cls-1",
    d: "m53.9,25.34c-15.78,0-28.58,12.79-28.58,28.58s12.79,28.58,28.58,28.58,28.58-12.79,28.58-28.58h0c0-15.78-12.79-28.58-28.58-28.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    className: "cls-1",
    cx: 86.12,
    cy: 23.67,
    r: 13.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8486",
    "data-name": "Path 8486",
    className: "cls-1",
    d: "m102.95,31.6l-.47-1.03-.73.85c-1.83,2.08-4.15,3.68-6.75,4.65l-.73.26.29.73c9.34,22.47-1.3,48.26-23.77,57.6-22.47,9.34-48.26-1.3-57.6-23.77-9.34-22.47,1.3-48.26,23.77-57.6,11.52-4.79,24.54-4.47,35.81.88l.69.33.3-.73c1.1-2.55,2.8-4.79,4.97-6.52l.88-.73-1.01-.52C70.97,2.04,62.49-.02,53.89,0,24.12,0,0,24.14,0,53.91s24.14,53.9,53.91,53.89,53.9-24.14,53.89-53.91c0-7.72-1.66-15.34-4.86-22.36v.07Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic2);
export default __webpack_public_path__ + "static/media/ionic2.c32df959c53213741073e1c399fe7d9e.svg";
export { ForwardRef as ReactComponent };